export const META_PIXEL_ID = '1367632915547845'

type MetaPixel = {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: (...args: unknown[]) => void
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & MetaPixel
    _fbq?: MetaPixel
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  try {
    if (!window.fbq) {
      const pixel = function (...args: unknown[]) {
        if (pixel.callMethod) pixel.callMethod(...args)
        else pixel.queue.push(args)
      } as ((...args: unknown[]) => void) & MetaPixel

      pixel.queue = []
      pixel.push = (...args: unknown[]) => pixel.queue.push(args)
      pixel.loaded = true
      pixel.version = '2.0'
      window.fbq = pixel
      if (!window._fbq) window._fbq = pixel

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      ;(document.head || document.body || document.documentElement).appendChild(script)
      window.fbq('init', META_PIXEL_ID)
    }
    window.fbq('track', 'PageView')
  } catch (error) {
    console.warn('Meta Pixel init failed:', error)
  }
}

export function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: "Prof d'Espagnol Prêt — Système complet 8 en 1",
    value: 27,
    currency: 'EUR',
  })
}
